export default "__VITE_ASSET__ec2e29f7__"